<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Multiselect from 'vue-multiselect';
import { REGIONES, getComunas, getProvincia } from '@/utils/chile-comunas';

export default {
    components: { Layout, PageHeader, Multiselect},
    data() {
        return {
            title: "Colegios",
            items: [
                {
                text: "Configuración",
                href: "/"
                },
                {
                text: "Colegios",
                active: true
                }
            ],
            colegioseleccionada: null,
            datoscolegios: [
            ],
            isLoadingMultiselect: false,
            colegioid_seleccion: '',                       //id colegio
            colegioid_editar: {},                       //id colegio
            habilitar_boton: false,
            editing: false,
            eventos: [], // Eventos asociados
            ColegioNoExiste: false,
            originalcolegio:'',
            isLoading:false,
            opciones:['Si','No'],
            phoneerror1:'',
            phoneerror2:'',
            phoneerror3:'',
            emailError1:'',
            emailError2:'',
            estado:{},
            regiones: REGIONES,
            regionEditar: null,
            comunaEditar: null,
            syncingColegio: false
        };
    },
    computed:{
        comunasFiltradasEditar() {
            if (!this.regionEditar) return [];
            return getComunas(this.regionEditar).map(c => c.comuna).sort();
        },
        fechaModificacionColegio() {
            if (!this.colegioid_seleccion) return null;
            const upd = this.colegioid_seleccion.updated_at;
            const cre = this.colegioid_seleccion.created_at;
            if (!upd || !cre || upd === cre) return null;
            const d = new Date(upd);
            if (isNaN(d)) return upd;
            const pad = n => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
        isEmailValid1() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegioid_editar.correo_colegio);
        },
        isEmailValid2() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(this.colegioid_editar.correo_orientador);
        },
        puedeGestionarColegio() {
            const rol = this.user && this.user.rol ? String(this.user.rol) : '';
            return rol !== '' && !['Laborante', 'Decana', 'Gastos'].includes(rol);
        }
    },
    watch: {
        regionEditar(val) {
            this.colegioid_editar.region = val || '';
            this.comunaEditar = null;
            this.colegioid_editar.comuna = '';
            this.colegioid_editar.provincia = '';
        },
        comunaEditar(val) {
            this.colegioid_editar.comuna = val || '';
            this.colegioid_editar.provincia = val ? getProvincia(this.regionEditar, val) : '';
        }
    },
    methods:{
        syncHubspotColegio() {
            this.syncingColegio = true;
            axios.post('/api/sync_hubspot_colegio', { id: this.colegioid_seleccion.id })
                .then(res => {
                    if (res.data.estado) {
                        this.colegioid_seleccion.hubspot_company_id = res.data.hubspot_company_id;
                        this.msg('success', res.data.mensaje);
                    } else {
                        this.msg('warning', res.data.mensaje);
                    }
                })
                .catch(() => this.msg('error', 'Error al conectar con HubSpot.'))
                .finally(() => { this.syncingColegio = false; });
        },
        validacion() {
            const campos = {
                //nombre_director: 'Nombre Director',
                //correo_colegio: 'Correo Director',
                //telefono_director: 'Teléfono Director',
                //telefono_colegio: 'Teléfono',
                //nombre_orientador: 'Nombre Orientador',
                //correo_colegio_2: 'Correo Orientador',
                //telefono_orientador: 'Teléfono Orientador',
                colegio_visitado: '¿Colegio Visitado?',
            };
            for (let campo in campos) {
                if (!this.colegioid_editar[campo]) {
                    this.msgval(campos[campo]);
                    return false;
                }
            }
            return true;
        },
        validateEmail1() {
            if (this.colegioid_editar.correo_colegio && !this.isEmailValid1) {
                this.emailError1 = 'El correo electrónico no es válido.';
            } else {
                this.emailError1 = '';
            }
        },
        validateEmail2() {
            if (this.colegioid_editar.correo_orientador && !this.isEmailValid2) {
                this.emailError2 = 'El correo electrónico no es válido.';
            } else {
                this.emailError2 = '';
            }
        },
        modificar_id(colegioseleccionada) {
            const colegio = colegioseleccionada;
            if (colegio) {
                this.colegioid_seleccion = colegio;
                this.originalcolegio = colegio;
                this.habilitar_boton = true;
            } else {
                this.habilitar_boton = false;
            }
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        toggleEdit() {
            this.originalcolegio = { ...this.colegioid_seleccion };
            if (this.editing) {
                //console.log('editar')
                if(this.validacion()){
                    this.isLoading=true
                    axios.post('/api/editar_colegio',this.colegioid_editar).then(res=>{
                        if(res.data.estado){
                            this.msg(res.data.color, res.data.mensaje);
                            this.colegioid_seleccion = res.data.colegio;
                            this.editing = false;
                            this.isLoading = false;
                        }else{
                            this.msg(res.data.color, res.data.mensaje);
                            this.isLoading = false;
                        }
                    }).catch(() => {
                        this.msg('error', 'Error al guardar el colegio');
                        this.isLoading = false;
                    })
                }
            } else {
                this.editing = !this.editing;
            }
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        consultarColegio() {
            //console.log('consultarColegio');
            const rbd = this.colegioseleccionada.rbd; // RBD del colegio seleccionado
            //console.log(rbd);
            axios.get(`/api/get_colegio/${rbd}`).then(response => {
                if(response.data.estado){
                    this.colegioid_seleccion = response.data.colegio;
                    this.eventos = response.data.colegio.eventos;
                    //console.log(this.colegioid_seleccion)
                    this.colegioid_editar = { ...response.data.colegio };
                    this.colegioid_editar.telefono_colegio = this.colegioid_seleccion.telefono;
                    this.colegioid_editar.colegio_visitado = this.colegioid_seleccion.colegio_visitado;
                    // Guardar valores antes de activar el watcher (que limpia comuna/provincia)
                    const savedRegion = this.colegioid_seleccion.region || null;
                    const savedComuna = this.colegioid_seleccion.comuna || null;
                    const savedProvincia = this.colegioid_seleccion.provincia || '';
                    this.regionEditar = savedRegion;
                    this.$nextTick(() => {
                        this.comunaEditar = savedComuna;
                        // Si la comuna no está en la lista (dato antiguo), restaurar texto directo
                        if (savedComuna && !this.comunasFiltradasEditar.includes(savedComuna)) {
                            this.colegioid_editar.comuna = savedComuna;
                            this.colegioid_editar.provincia = savedProvincia;
                        }
                    });
                    this.colegioid_editar.nombre_orientador=this.colegioid_seleccion.nombre_orientador;
                    this.colegioid_editar.correo_orientador=this.colegioid_seleccion.correo_orientador;
                    this.colegioid_editar.telefono_orientador=this.colegioid_seleccion.telefono_orientador;
                    this.colegioid_editar.nombre_director=this.colegioid_seleccion.nombre_director;
                    this.colegioid_editar.correo_colegio=this.colegioid_seleccion.correo_colegio;
                    this.colegioid_editar.telefono_director=this.colegioid_seleccion.telefono_director;
                    if (this.colegioid_seleccion.estado_colegio!=null) {
                        //this.colegioid_editar.estado=this.estados.find(est=>est.codigo==this.colegioid_seleccion.estado_colegio)
                    }
                }else{
                    // console.log('Error al consultar')
                    console.log("No existen datos del colegio: "+rbd);
                    this.colegioid_seleccion = false;
                    this.eventos = '';
                    this.ColegioNoExiste=true;
                }
            });
        },
        handleKeydown(event) {
            // Verifica si la tecla presionada es Enter o Enter del teclado numérico
            if (event.key == "Enter" || event.code == "Enter" || event.keyCode == 13) {
                event.preventDefault(); // Previene comportamientos predeterminados (como un submit en formularios)
                //this.consultarColegio();
            }
        },
        formatFecha(fecha) {
            if (!fecha) return "-";
            const opciones = { year: "numeric", month: "2-digit", day: "2-digit" };
            return new Date(fecha).toLocaleDateString("es-ES", opciones);
        },
        formatFechaHora(fecha) {
            if (!fecha) return "-";
            const opciones = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" };
            return new Date(fecha).toLocaleString("es-ES", opciones);
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento.codigo);
            window.location.href = "/web/configuracion/eventos";
        },
        estadoEvento(evento) {
            const estilos = {
                'Vigente':   { label: 'Vigente',   style: 'background:#252C5F;color:#fff;border-radius:10px;padding:3px 10px;font-size:.78rem;' },
                'Cerrado':   { label: 'Cerrado',   style: 'background:#6c757d;color:#fff;border-radius:10px;padding:3px 10px;font-size:.78rem;' },
                'Cancelado': { label: 'Cancelado', style: 'background:#dc3545;color:#fff;border-radius:10px;padding:3px 10px;font-size:.78rem;' },
            };
            // Si ya pasó la fecha de término, mostrar Cerrado
            if (evento.fecha_termino && new Date(evento.fecha_termino) < new Date()) {
                return estilos['Cerrado'];
            }
            const estado = Array.isArray(evento.estado_actividad)
                ? (evento.estado_actividad[0] && evento.estado_actividad[0].nombre ? evento.estado_actividad[0].nombre : evento.estado_actividad[0])
                : evento.estado_actividad;
            return estilos[estado] || { label: estado || '—', style: 'background:#61B7E4;color:#fff;border-radius:10px;padding:3px 10px;font-size:.78rem;' };
        },
        crear_evento(evento){
            localStorage.setItem('colegio',JSON.stringify(this.colegioid_seleccion));
            window.location.href = "/web/configuracion/crearevento";
        },
        customLabel(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        customEstado(estado) {
            return `${estado.nombre}`;
        },
        fetchColegios(query) {
            if (query.length < 3) return; // Buscar después de escribir al menos 3 letras
            this.isLoading = true;
            axios.get(`/api/colegios?search=${query}`)
                .then(response => {
                this.datoscolegios = response.data;
                })
                .catch(error => console.error(error))
                .finally(() => this.isLoading = false);
        },
        buscarColegio() {
            console.log('Colegio seleccionado:', this.colegioseleccionada);
        },
        formatPhoneNumber1() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_director.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_director = "+" + digits;
        },
        validatePhoneNumber1() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_director.length !== 12) {
                this.phoneerror1 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror1 = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        formatPhoneNumber2() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_colegio.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_colegio = "+" + digits;
        },
        validatePhoneNumber2() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_colegio.length !== 12) {
                this.phoneerror2 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror2 = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        formatPhoneNumber3() {
            // Elimina todo lo que no sea número
            let digits = this.colegioid_editar.telefono_orientador.replace(/\D/g, "");

            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }

            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }

            // Actualiza el input con el formato correcto
            this.colegioid_editar.telefono_orientador = "+" + digits;
        },
        validatePhoneNumber3() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.colegioid_editar.telefono_orientador.length !== 12) {
                this.phoneerror3 = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror3 = "";
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);

            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        }
    },
    mounted(){
        if (localStorage.getItem("colegio")) {
            const colegio = localStorage.getItem("colegio");
            try {
                this.colegioseleccionada = JSON.parse(colegio);
            } catch (error) {
                this.colegioseleccionada = null;
            }
            localStorage.removeItem("colegio");
            if (this.colegioseleccionada) {
                this.consultarColegio();
            }
        }

    },
    created() {
        this.isLoading=true
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.datoscolegios = response.data.colegios;
                if (localStorage.getItem("rbd_colegio")) {
                    const rbd_colegio = localStorage.getItem("rbd_colegio");
                    localStorage.removeItem("rbd_colegio");
                    this.colegioseleccionada=this.datoscolegios.find(colegio=>colegio.rbd==rbd_colegio)
                    this.consultarColegio();
                }
            }
        }
        ).catch(error => console.error(error)
        ).finally(() => this.isLoading = false);
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-buildings font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Colegios</h5>
                            <small class="text-white" style="opacity:.8;">Gestiona los colegios de la plataforma</small>
                        </div>
                    </div>
                    <div class="card-body py-3">
                        <div class="row justify-content-center">
                            <div class="col-md-8">
                                <label class="font-weight-semibold mb-1" style="color:#252C5F;">
                                    <i class="bx bx-search-alt mr-1"></i> Buscar por nombre o RBD
                                </label>
                                <multiselect
                                    v-model="colegioseleccionada"
                                    :options="datoscolegios"
                                    :searchable="true"
                                    :internal-search="true"
                                    :custom-label="customLabel"
                                    placeholder="Ej: Colegio San Pedro o 9321..."
                                    @select="consultarColegio"
                                    selectLabel="Seleccionar"
                                    selectedLabel="✓"
                                    deselectLabel="Remover"
                                >
                                    <template v-slot:noOptions><span class="text-muted">Sin resultados disponibles</span></template>
                                    <template v-slot:noResult><span class="text-muted">No se encontraron coincidencias</span></template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── DETALLE COLEGIO ── -->
            <div class="col-12" v-if="colegioseleccionada && colegioid_seleccion">
                <div class="card">
                    <!-- Sub-header con nombre y botones -->
                    <div class="card-header py-3 d-flex align-items-center justify-content-between"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <div>
                            <h5 class="text-white mb-0">
                                <i class="bx bx-buildings mr-2"></i>{{ colegioid_seleccion.nombre }}
                            </h5>
                            <small class="text-white" style="opacity:.8;">RBD: {{ colegioid_seleccion.rbd }}</small>
                        </div>
                        <div class="d-flex" style="gap:8px;">
                            <button @click="crear_evento" class="btn-ugm-white" v-if="puedeGestionarColegio">
                                <i class="bx bx-calendar-plus mr-1"></i> Crear Evento
                            </button>
                            <button v-if="editing && puedeGestionarColegio" @click="cancelEdit" class="btn-ugm-white">
                                <i class="fas fa-times mr-1"></i> Cancelar
                            </button>
                            <button @click="toggleEdit" :class="editing ? 'btn-ugm-gold' : 'btn-ugm-white'" v-if="puedeGestionarColegio">
                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'" class="mr-1"></i>
                                {{ editing ? 'Guardar cambios' : 'Editar' }}
                            </button>
                        </div>
                    </div>

                    <div class="card-body pt-4">

                        <!-- ── MODO VISTA ── -->
                        <div v-if="!editing">
                            <div class="row">
                                <div class="col-md-6">
                                    <!-- Barra sección izquierda -->
                                    <div class="d-flex align-items-center mb-3">
                                        <div style="width:4px;height:20px;background:#252C5F;border-radius:2px;margin-right:8px;"></div>
                                        <span class="font-weight-bold" style="color:#252C5F;">Información General</span>
                                    </div>
                                    <table class="table table-sm table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td class="font-weight-bold text-dark" style="width:45%">RBD</td>
                                                <td>{{ colegioid_seleccion.rbd }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">HubSpot ID</td>
                                                <td>
                                                    <span v-if="colegioid_seleccion.hubspot_company_id" class="badge badge-pill badge-success">{{ colegioid_seleccion.hubspot_company_id }}</span>
                                                    <span v-else class="badge badge-pill badge-danger">No encontrado</span>
                                                    <b-button size="sm" class="ml-2 d-inline-flex align-items-center"
                                                        style="background:#252C5F;border-color:#252C5F;color:#fff;font-size:11px;"
                                                        :disabled="syncingColegio" @click="syncHubspotColegio()">
                                                        <i :class="syncingColegio ? 'bx bx-loader bx-spin mr-1' : 'bx bx-refresh mr-1'"></i>
                                                        {{ syncingColegio ? 'Buscando...' : 'Buscar ID' }}
                                                    </b-button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Dirección</td>
                                                <td>{{ colegioid_seleccion.direccion }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Comuna</td>
                                                <td>{{ colegioid_seleccion.comuna }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Provincia</td>
                                                <td>{{ colegioid_seleccion.provincia }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Región</td>
                                                <td>{{ colegioid_seleccion.region }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Nombre Director</td>
                                                <td>{{ colegioid_seleccion.nombre_director }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Correo Director</td>
                                                <td>{{ colegioid_seleccion.correo_colegio }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Teléfono Director</td>
                                                <td>{{ colegioid_seleccion.telefono_director }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex align-items-center mb-3">
                                        <div style="width:4px;height:20px;background:#61B7E4;border-radius:2px;margin-right:8px;"></div>
                                        <span class="font-weight-bold" style="color:#252C5F;">Datos de Contacto</span>
                                    </div>
                                    <table class="table table-sm table-borderless mb-0">
                                        <tbody>

                                            <tr>
                                                <td class="font-weight-bold text-dark">¿Colegio visitado?</td>
                                                <td>
                                                    <span :style="colegioid_seleccion.colegio_visitado=='Sí' ? 'color:#28a745;font-weight:600' : ''">
                                                        {{ colegioid_seleccion.colegio_visitado || '—' }}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Teléfono Colegio</td>
                                                <td>{{ colegioid_seleccion.telefono }}</td>
                                            </tr>

                                            <tr>
                                                <td class="font-weight-bold text-dark">Nombre Orientador</td>
                                                <td>{{ colegioid_seleccion.nombre_orientador }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Correo Orientador</td>
                                                <td>{{ colegioid_seleccion.correo_orientador }}</td>
                                            </tr>
                                            <tr>
                                                <td class="font-weight-bold text-dark">Teléfono Orientador</td>
                                                <td>{{ colegioid_seleccion.telefono_orientador }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- Última actualización -->
                            <div class="mt-3 text-right" style="font-size:.8rem;color:#888;">
                                <i class="bx bx-time-five mr-1"></i>
                                Última actualización: {{ fechaModificacionColegio || '—' }}
                            </div>

                            <!-- Eventos Asociados -->
                            <div v-if="eventos && eventos.length > 0" class="mt-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div style="width:4px;height:20px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                    <span class="font-weight-bold" style="color:#252C5F;">Eventos Asociados</span>
                                    <span class="badge ml-2" style="background:#CB9700;color:#fff;border-radius:10px;padding:3px 9px;">{{ eventos.length }}</span>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-hover mb-0" style="border-radius:8px;overflow:hidden;">
                                        <thead style="background:#252C5F;color:#fff;">
                                            <tr>
                                                <th class="font-weight-normal py-2 pl-3">Estado</th>
                                                <th class="font-weight-normal py-2">Código</th>
                                                <th class="font-weight-normal py-2">Nombre Difusión</th>
                                                <th class="font-weight-normal py-2">Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="evento in eventos" :key="evento.id">
                                                <td class="pl-3">
                                                    <span class="badge" :style="estadoEvento(evento).style">
                                                        {{ estadoEvento(evento).label }}
                                                    </span>
                                                </td>
                                                <td><code>{{ evento.codigo }}</code></td>
                                                <td>{{ evento.nombre_difusion }}</td>
                                                <td>
                                                    <b-button size="sm" @click="ver_evento(evento)"
                                                        style="background:#252C5F;border-color:#252C5F;color:#fff;">
                                                        <i class="bx bx-show mr-1"></i> Ver
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else class="mt-3 text-muted text-center py-3" style="border:1px dashed #dee2e6;border-radius:8px;">
                                <i class="bx bx-calendar-x font-size-20 d-block mb-1"></i>
                                Sin eventos asociados a este colegio
                            </div>
                        </div>

                        <!-- ── MODO EDICIÓN ── -->
                        <div v-else>
                            <!-- Sección datos del colegio -->
                            <div class="d-flex align-items-center mb-3">
                                <div style="width:4px;height:20px;background:#252C5F;border-radius:2px;margin-right:8px;"></div>
                                <span class="font-weight-bold" style="color:#252C5F;">Datos del Colegio</span>
                            </div>
                            <div class="row">
                                <!-- Columna izquierda: igual orden que la vista -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>RBD</label>
                                        <input type="text" v-model="colegioid_editar.rbd" disabled class="form-control bg-light">
                                    </div>
                                    <div class="form-group">
                                        <label>Dirección</label>
                                        <input type="text" v-model="colegioid_editar.direccion" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Comuna</label>
                                        <multiselect v-model="comunaEditar" :options="comunasFiltradasEditar"
                                            :placeholder="regionEditar ? 'Seleccionar comuna' : 'Primero elige una región'"
                                            selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Limpiar"
                                            :style="!regionEditar ? 'pointer-events:none;opacity:.55;' : ''">
                                            <template v-slot:noOptions><span class="text-muted">Sin comunas</span></template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label>Provincia</label>
                                        <input type="text" :value="colegioid_editar.provincia" class="form-control" readonly style="background:#f8f9fa;cursor:default;">
                                    </div>
                                    <div class="form-group">
                                        <label>Región</label>
                                        <multiselect v-model="regionEditar" :options="regiones"
                                            placeholder="Seleccionar región" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Limpiar">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label>Nombre Director</label>
                                        <input type="text" v-model="colegioid_editar.nombre_director" class="form-control" @keydown="restrictInput_withspace">
                                    </div>
                                    <div class="form-group">
                                        <label>Correo Director</label>
                                        <input type="text" v-model="colegioid_editar.correo_colegio" class="form-control" @blur="validateEmail1">
                                        <small v-if="emailError1" class="text-danger">{{ emailError1 }}</small>
                                    </div>
                                    <div class="form-group">
                                        <label>Teléfono Director</label>
                                        <input type="text" v-model="colegioid_editar.telefono_director" class="form-control" @input="formatPhoneNumber1" @blur="validatePhoneNumber1" @keydown="restrictToNumbers" maxlength="12">
                                        <small v-if="phoneerror1" class="text-danger">{{ phoneerror1 }}</small>
                                    </div>
                                </div>
                                <!-- Columna derecha: igual orden que la vista -->
                                <div class="col-md-6">
                                    <div class="form-group" v-if="fechaModificacionColegio">
                                        <label class="text-muted" style="font-size:.8rem;">Última actualización</label>
                                        <div class="form-control bg-light text-muted" style="font-size:.85rem;cursor:default;">{{ fechaModificacionColegio }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label>¿Colegio visitado? <span class="text-danger">*</span></label>
                                        <multiselect v-model="colegioid_editar.colegio_visitado" :options="opciones"
                                            placeholder="Seleccionar" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                        </multiselect>
                                    </div>
                                    <div class="form-group">
                                        <label>Teléfono Colegio</label>
                                        <input type="text" v-model="colegioid_editar.telefono_colegio" class="form-control" @input="formatPhoneNumber2" @blur="validatePhoneNumber2" @keydown="restrictToNumbers" maxlength="12">
                                        <small v-if="phoneerror2" class="text-danger">{{ phoneerror2 }}</small>
                                    </div>
                                    <div class="form-group">
                                        <label>Nombre Orientador</label>
                                        <input type="text" v-model="colegioid_editar.nombre_orientador" class="form-control" @keydown="restrictInput_withspace">
                                    </div>
                                    <div class="form-group">
                                        <label>Correo Orientador</label>
                                        <input type="email" v-model="colegioid_editar.correo_orientador" class="form-control" @blur="validateEmail2">
                                        <small v-if="emailError2" class="text-danger">{{ emailError2 }}</small>
                                    </div>
                                    <div class="form-group">
                                        <label>Teléfono Orientador</label>
                                        <input type="text" v-model="colegioid_editar.telefono_orientador" class="form-control" @input="formatPhoneNumber3" @blur="validatePhoneNumber3" @keydown="restrictToNumbers" maxlength="12">
                                        <small v-if="phoneerror3" class="text-danger">{{ phoneerror3 }}</small>
                                    </div>
                                    <div class="form-group">
                                        <label>Tipo Educación</label>
                                        <input type="text" v-model="colegioid_editar.tipo_educacion" class="form-control">
                                    </div>
                                    <div class="form-group">
                                        <label>Nivel Socioeconómico</label>
                                        <input type="text" v-model="colegioid_editar.nivel_socioeconomico" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </Layout>
</template>

<style scoped>
.btn-ugm-white {
    background: #fff !important;
    color: #252C5F !important;
    border: 1px solid #fff !important;
    border-radius: 6px;
    padding: 5px 14px;
    font-size: .8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-white:hover { opacity: .85; }

.btn-ugm-gold {
    background: #CB9700 !important;
    color: #fff !important;
    border: 1px solid #CB9700 !important;
    border-radius: 6px;
    padding: 5px 14px;
    font-size: .8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-gold:hover { opacity: .88; }
</style>
